import { render, staticRenderFns } from "./BuildingInvoiceTable.vue?vue&type=template&id=68b6faf6&scoped=true&"
import script from "./BuildingInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./BuildingInvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./BuildingInvoiceTable.vue?vue&type=style&index=0&id=68b6faf6&scoped=true&lang=css&"
import style1 from "./BuildingInvoiceTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b6faf6",
  null
  
)

export default component.exports